import { useEffect, useState } from 'react';
import fetchQuote from '../../api/fetch-quote';
import useInsensitiveSearchParams from '../use-insensitive-search-params';

function useQuoteData() {
  const [quoteData, setQuoteData] = useState(null);
  const [loadingQuote, setLoadingQuote] = useState(true);
  const quoteId = useInsensitiveSearchParams().get('q') ?? '';
  useEffect(() => {
    if (!quoteId) {
      setLoadingQuote(false);
      return;
    }
    setLoadingQuote(true);
    fetchQuote(quoteId)
      .then((quoteData) => {
        setQuoteData(quoteData);
      })
      .catch((err) => {
        window['newrelic']?.noticeError('Error loading quote in account step - ', err);
      })
      .finally(() => setLoadingQuote(false));
  }, [quoteId]);

  return {
    loadingQuote,
    quoteData,
  };
}

export default useQuoteData;
